import CircleIcon from '@mui/icons-material/Circle';
import { green, grey, red, yellow } from '@mui/material/colors';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { Tooltip } from '@mui/material';


function DataTable({indicatoriPratica}){
    var totalCol = []
    var rows =[]
    var valueRows ={}
    const codificaColori = (color) => {
        if(color ==='Gray' ||color ==='Grey'){
          return grey[500]
    
        }
        else if(color ==='Green'){
          return green[500]
    
        }
        else if(color ==='Yellow'){
          return yellow[500]
    
        }
        else if(color==='Red'){
          return red[500]
          
        }else{
          return 'transparent'
        }
    }   
/*        const columns1 = [{ field: 'INDICATORI', headerName: 'INDICATORI', width:350 , renderCell: (params) => (<Tooltip title={params.value}><span style={{whiteSpace:"nowrap", overflow: "hidden",
          textOverflow: "ellipsis"}}>{params.value}</span></Tooltip>)} ,{field: 'ACCOUNT', headerName: 'ACCOUNT', width: 130,
        renderCell: (params) => (
        <CircleIcon sx={{ color: codificaColori(params.value) }} />
      )}]*/


  const columns1 = [
    {
      field: 'INDICATORI',
      headerName: 'INDICATORI',
      width: 350,
      renderCell: (params) => (
        <Tooltip title={params.value}>
        <span style={{
          whiteSpace: "normal",  // Permette il testo su più righe
          overflowWrap: "break-word", // Evita overflow del testo
          display: "block", // Assicura il wrapping del testo
          wordBreak: "break-word", // Spezza le parole lunghe se necessario
          padding: "4px 0", // Più spazio sopra e sotto
          lineHeight: "1.4", // Aumenta lo spazio tra le righe di testo
        }}>
          {params.value}
        </span>
        </Tooltip>
      )
    },
    {
      field: 'ACCOUNT',
      headerName: 'ACCOUNT',
      width: Math.min(7 * 8 + 50, 200),
      align: 'center',
      renderCell: (params) => (
        <CircleIcon sx={{ color: codificaColori(params.value) }} />
      )
    }
  ];
  const columns2 = indicatoriPratica.contacts?.map((c,idx) => ({
    field: c.oploncodicefiscalec || `contact_${idx}`,
    headerName: c.name,
    width: Math.min(c.name.length * 8 + 50, 200),
    align: 'center',
    renderCell: (params) => (
      <CircleIcon sx={{ color: codificaColori(params.value) }} />
    ),
  }))

  totalCol = columns1.concat(columns2)
  if (columns2) {
    Object.keys(indicatoriPratica?.indicatori).forEach((name, i) => {
      valueRows = Object.assign({ 'id': i })
      for (var z = 0; z < totalCol?.length; z++) {
        if (totalCol[z].field === 'ACCOUNT') {
          valueRows = Object.assign(valueRows, { [totalCol[z].field]: indicatoriPratica?.account.listIndicatori[i] })

        } else if (totalCol[z].field === 'INDICATORI') {
          valueRows = Object.assign(valueRows, { [totalCol[z].field]: indicatoriPratica?.indicatori[name] })
        } else if (totalCol[z].field !== 'INDICATORI' && totalCol[z].field !== 'ACCOUNT') {
          valueRows = Object.assign(valueRows, { [totalCol[z].field]: indicatoriPratica?.contacts[z - 2].indicatori[i] })
        }

      }
      rows.push(valueRows)
    })
  }
    return (
      <DataGrid
        rows={rows}
        columns={totalCol}
        disableColumnFilter={true}
        headerHeight={30}
        autoHeight={true}
        disableColumnMenu={true}
        hideFooter={true}
        hideFooterPagination={true}
        getRowHeight={() => 'auto'}
        sx={{ width: '100%', maxHeight: 'none',zIndex: 2500}}
      />
            );
};
export default DataTable; 